export default {
      id: "gars_plan-usage",
      viewBox: "0 0 145 135",
      url: "../dist/images/" + "sprite.svg#gars_plan-usage",
      toString: function () {
        return this.url;
      }
    }